import api from './api';
import { LossListResponse } from '../types/loss';

export const lossService = {
    // GET /api/site/losses?page=1&limit=10
    list: async (params?: {
        page?: number;
        limit?: number;
        search?: string;
    }): Promise<LossListResponse> => {
        const response = await api.get('losses', { params });
        return response.data;
    },

    // GET /api/site/losses/:id
    getById: async (id: string): Promise<{ success: boolean; data: any }> => {
        const response = await api.get(`losses/${id}`);
        return response.data;
    },
};
